import type { NetInfoState } from '@react-native-community/netinfo'

type TConnectivity = Pick<NetInfoState, 'isConnected' | 'isInternetReachable'>

/**
 * A device can be attached to a network (`isConnected`) without internet
 */
export const hasInternetConnection = (state: TConnectivity): boolean =>
  Boolean(state.isConnected && state.isInternetReachable)

/**
 * NetInfo uses `null` while checking reachability. Only an explicit `false` means offline for user-facing feedback
 */
export const isConfirmedOffline = (state: TConnectivity): boolean =>
  state.isConnected === false || state.isInternetReachable === false
